import { Avatar, Grid } from '@mui/material';

export const uniqueCharsUpperCase = (string) =>
  [...string.toUpperCase()].filter(function (item, i, ar) {
    return ar.indexOf(item) === i;
  });

export const getIndexes = (char, string) => {
  const indexes = [];
  for (let i = 0; i < string.length; i++) {
    if (string[i].toUpperCase() === char.toUpperCase()) {
      indexes.push(i);
    }
  }
  return indexes;
};

export const prepareGuessFeedback = (playerName, guess) => {
  var uniqueCharsInGuess = uniqueCharsUpperCase(guess);
  var uniqueCharsInPlayerName = uniqueCharsUpperCase(playerName);

  const uniqueCharsInGuessWithMetaData = {};

  // Prepare Index Info
  uniqueCharsInGuess.forEach((char) => {
    uniqueCharsInGuessWithMetaData[char] = {
      indexesInGuess: getIndexes(char, guess),
      indexesInPlayerName: getIndexes(char, playerName),
    };
  });

  // "Blank" Response
  const guessWithMeta = [...guess.toUpperCase()].map((char) => ({
    char,
  }));

  // Mark Greens
  uniqueCharsInPlayerName.forEach((charInPlayerName) => {
    const charMeta = uniqueCharsInGuessWithMetaData[charInPlayerName];
    if (charMeta) {
      charMeta.indexesInPlayerName.forEach((indexInPN) => {
        if (charMeta.indexesInGuess.includes(indexInPN)) {
          guessWithMeta[indexInPN].isIncludedInWord = true;
          guessWithMeta[indexInPN].isInCorrectPosition = true;
          charMeta.indexesInPlayerName = charMeta.indexesInPlayerName.filter(
            (val) => val !== indexInPN
          );
          charMeta.indexesInGuess = charMeta.indexesInGuess.filter(
            (val) => val !== indexInPN
          );
        }
      });
    }
  });

  // Mark Yellows
  uniqueCharsInPlayerName.forEach((charInPlayerName) => {
    const charMeta = uniqueCharsInGuessWithMetaData[charInPlayerName];
    if (charMeta) {
      for (var i = 0; i < charMeta.indexesInPlayerName.length; i++) {
        const indexToMarkPresent = charMeta.indexesInGuess[0];
        if (guessWithMeta[indexToMarkPresent]) {
          guessWithMeta[indexToMarkPresent].isIncludedInWord = true;
          guessWithMeta[indexToMarkPresent].isInCorrectPosition = false;
        }
      }
    }
  });
  return guessWithMeta;
};

const GuessLetter = ({ char, isIncludedInWord, isInCorrectPosition }) => {
  let feedbackColour = 'grey';
  let colour = 'black';

  if (isIncludedInWord) {
    feedbackColour = '#FFBF00';
    colour = 'black';
  }
  if (isInCorrectPosition) {
    feedbackColour = 'green';
    colour = 'white';
  }
  return (
    <Grid item>
      <Avatar
        variant="rounded"
        sx={{ margin: '5px', bgcolor: feedbackColour, color: colour }}
      >
        {char !== ' ' && char.toUpperCase()}
      </Avatar>
    </Grid>
  );
};

export const Guess = ({ guess, playerName, showFeedback }) => {
  let guessFeedback;
  if (showFeedback) {
    guessFeedback = prepareGuessFeedback(playerName, guess);
  } else {
    guessFeedback = [...guess].map((char) => ({
      char,
    }));
  }
  return (
    <Grid key={guess} container justifyContent="center">
      {guessFeedback.map((charWithMeta) => (
        <GuessLetter
          char={charWithMeta.char}
          isIncludedInWord={charWithMeta.isIncludedInWord}
          isInCorrectPosition={charWithMeta.isInCorrectPosition}
        />
      ))}
      <br />
    </Grid>
  );
};
